enum HeaderVariantType {
  'Basic',
  'Extended',
}

export default HeaderVariantType;
